module.exports = __webpack_public_path__ + "static/media/saint-laurent1.110e22ee.jpg";